import { CrmComponentResolverProps } from ".";

export function CrmComponentResolver({
    selectedCrmSystem,
    crmSystemComponentsMap,
    fallback
}: CrmComponentResolverProps){
    return crmSystemComponentsMap[selectedCrmSystem] || fallback || null;
}

